module.exports = __webpack_public_path__ + "img/10-3.253c11c9.png";